module.exports = __webpack_public_path__ + "img/thu-tuc-hanh-chinh-icon.fdac467d.svg";